import React from "react";
import ExercisesShop from "../../components/ExercisesShop/ExercisesShop";

function Exercisespage() {
  return (
    <div>
      <ExercisesShop />
    </div>
  );
}

export default Exercisespage;
